import { useDeviceName } from 'lib/api/myRobot';
import {
  Status_EmergencyStopState,
  Status_GPSLocation,
  Status_OperationMode,
} from 'lib/generated/proto/roboverse_platform_protos/statekeeping/Reported/Status';

import { KeyPathParser, useTwinQuerySub } from '../signalR';

export function useReportedStatus() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.Status.keyPathParser;
  const { data } = useTwinQuerySub(keyPath(deviceName), parser);

  return { status: data };
}

export function useEmergencyStopState() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.Status.emergencyStopState;
  const { data, updateState } = useTwinQuerySub(keyPath(deviceName), parser);

  function setEmergencyStop(stopped: boolean) {
    const newState = Status_EmergencyStopState.create({ ...data, softwareStopped: stopped });
    updateState(newState);
  }

  return { data, setEmergencyStop };
}

/**
 * Only fetch the state keeping data
 */
export function useStatusBattery() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.Status.battery;
  const { data } = useTwinQuerySub(keyPath(deviceName), parser);

  return { battery: data };
}

export function useStatusPowerPolicy() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.Status.powerPolicy;
  const { data } = useTwinQuerySub(keyPath(deviceName), parser);

  return { powerPolicy: data };
}

export function useStatusOperationMode() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.Status.operationMode;
  const { data: operationMode } = useTwinQuerySub(keyPath(deviceName), parser);

  const onMission = operationMode === Status_OperationMode.ON_MISSION;
  return { operationMode, onMission };
}

export function useStatusHasArm() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.Status.hasArm;
  const { data: hasArm } = useTwinQuerySub(keyPath(deviceName), parser);

  return { hasArm };
}

export function useStatusLocation() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.Status.location;
  const { data: location } = useTwinQuerySub(keyPath(deviceName), parser);

  const hasLocation = location.latitude !== 0 && location.longitude !== 0;

  return {
    hasLocation,
    location: {
      ...location,
    } as Status_GPSLocation,
  };
}

export function useShouldRobotRestart() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.Status.shouldRobotRestart;
  const { data: shouldRobotRestart } = useTwinQuerySub(keyPath(deviceName), parser);

  return {
    shouldRobotRestart,
  };
}
